import {domReady} from '@roots/sage/client'
//import 'bootstrap'; // Import Bootstrap
import compareBlockPositions from 'wa-scripts.1/misc/overlap'

const main = async ( err ) => {
  	if ( err ) {
		// handle hmr errors
		console.error( err )
  	}

	// Make header invisible over first hero block
	let navbar = jQuery( 'header nav.navbar' )
	let firstHero = jQuery( 'main#main .jumbotron.hero' )

	function addHeroClass() {
		if( firstHero.length ) {
			let removeClass = compareBlockPositions( navbar, firstHero ).inside
			//console.log(addClass)

			if( removeClass ) {
				navbar.removeClass( 'not-overlapping-hero' )
			} else {
				navbar.addClass( 'not-overlapping-hero' )
			}
		} else {
			navbar.addClass( 'not-overlapping-hero' )
		}
	}

	jQuery( document ).ready( function( ) {
		//addHeroClass()
	} )

	jQuery( window ).scroll( function( ) {
		//addHeroClass()
  		jQuery( 'html' ).attr( 'data-scroll', window.scrollY )
	} )

	jQuery( window ).ready( function( ) {
		//addHeroClass()
  		jQuery( 'html' ).attr( 'data-scroll', window.scrollY )
	} )
}

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady( main )
import.meta.webpackHot?.accept( main )